import React from "react";
import CopyrightAndLegal from "components/ui/copyright-and-legal";
import {
  Wrapper,
  Title,
  Description,
  Copy,
  Info,
  InfoColumn,
  InfoTitle,
  InfoLink,
  Row,
  SocialLinksWrapper,
  SocialLinkWrapper,
  InfoText,
} from "./index.styled";
import Button from "components/ui/button";
import { useStaticQuery, graphql } from "gatsby";

const Footer = ({ className, location }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      footerContent {
        content {
          adress
          adressTitle
          description
          link {
            linkText
            linkUrl
          }
          mail
          phone {
            phoneItem
            phoneText
          }
          contactTitle
          social_media_links {
            title
            url
            target
            iconUrl
          }
          title
        }
      }
    }
  `);

  const content = data?.footerContent?.content?.[0] || {};
  const title = content.title ?? '';
  const description = content.description ?? '';
  const link = content.link ?? { linkText: '', linkUrl: '' };
  const contactTitle = content.contactTitle ?? '';
  const mail = content.mail ?? '';
  const phone = content.phone ?? { phoneItem: '', phoneText: '' };
  const adressTitle = content.adressTitle ?? '';
  const adress = content.adress ?? '';
  const social_media_links = content.social_media_links ?? [];

  return (
    <Wrapper className={className} $location={location}>
      <Row $location={location}>
        <Copy>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <Button link={link.linkUrl}>{link.linkText}</Button>
        </Copy>
        <Info>
          <InfoColumn>
            <InfoTitle>{contactTitle}</InfoTitle>
            {phone.phoneText ? (
              <InfoLink target="_blank" href={`tel:${phone.phoneItem || phone.phoneText}`}>
                {phone.phoneText}
              </InfoLink>
            ) : null}
            {mail ? (
              <InfoLink target="_blank" href={`mailto:${mail}`}>
                {mail}
              </InfoLink>
            ) : null}
            <SocialLinksWrapper>
              {social_media_links.map(
                (item, i) =>
                  item.url && item.iconUrl ? (
                    <SocialLinkWrapper
                      key={i}
                      href={item.url}
                      target={item.target || '_blank'}
                      rel="noopener noreferrer"
                      aria-label={item.title}
                    >
                      <img src={item.iconUrl} alt={item.title || ''} />
                    </SocialLinkWrapper>
                  ) : null
              )}
            </SocialLinksWrapper>
          </InfoColumn>
          <InfoColumn>
            <InfoTitle>{adressTitle}</InfoTitle>
            <InfoLink href="#">
              <InfoText>{adress}</InfoText>
            </InfoLink>
          </InfoColumn>
        </Info>
      </Row>
      <CopyrightAndLegal />
    </Wrapper>
  );
};

export default Footer;
